import events from '../events/events';

let ghost;
let DnD = {}
let isIE = (typeof document.createElement('span').dragDrop === 'function');

DnD.install = (Vue) =>
{
    Vue.directive('draggable',
    {
        bind(el, binding, vnode)
        {
            if ( ! binding.value) return;
            if ( ! Vue.onduro.hasRole('planner')) return;

            el.setAttribute('data-item', JSON.stringify(binding.value));

            const dragStart = (ev) =>
            {
                el.classList.add('dragging');
                document.body.classList.add('dragging');

                if (ev.dataTransfer.setDragImage)
                {
                    let offsetX = ev.offsetX,
                        offsetY = ev.offsetY;

                    if (ev.target.classList.contains('item-new')) {
                        offsetX = ev.offsetX - 20;
                        offsetY = ev.offsetY - 10;
                    }

                    ghost = el.cloneNode(true);
                    ghost.style.position = 'absolute';
                    ghost.style.top = '-1000px';
                    ghost.style.right = '-1000px';
                    ghost.classList.add('ghost');
                    document.body.appendChild(ghost);

                    ev.dataTransfer.setDragImage(ghost, offsetX, offsetY);
                }

                ev.dataTransfer.effectAllowed = 'move';
                ev.dataTransfer.setData('text', el.getAttribute('data-item'));

                setTimeout(() =>
                {
                    events.$emit('drag.start', binding.value);

                    // close toolbox on drag start
                    events.$emit('toolbox.close');
                });
            }

            const dragEnd = () =>
            {
                events.$emit('drag.end');

                if (ghost) ghost.parentNode.removeChild(ghost);
                el.classList.remove('dragging');
                document.body.classList.remove('dragging');
            }

            el.setAttribute('draggable', true);
            el.addEventListener('dragstart', dragStart);
            el.addEventListener('dragend', dragEnd);
        },

        componentUpdated (el, binding, vnode)
        {
            if ( ! binding.value)
            {
                el.setAttribute('draggable', false);
            }
            else
            {
                // update bindings
                el.setAttribute('data-item', JSON.stringify(binding.value));

                el.setAttribute('draggable', true);
            }
        },

        unbind(el, binding, vnode)
        {
            el.setAttribute('draggable', false);
            el.removeEventListener('dragstart', {});
            el.removeEventListener('dragend', {});
        }
    });

    Vue.directive('droppable',
    {
        bind (el, binding, vnode)
        {
            el.setAttribute('data-target', binding.value.target);

            const drop = (ev) =>
            {
                if (ev.preventDefault) ev.preventDefault()
                if (ev.stopPropagation) ev.stopPropagation()

                const data = ev.dataTransfer.getData('text')

                binding.value.callback.call(el, data, el.getAttribute('data-target'))
                ev.target.classList.remove('dragover')
            }

            const dragOver = (ev) =>
            {
                if (ev.preventDefault) ev.preventDefault()
                if (ev.target.classList) ev.target.classList.add('dragover')
            }

            const dragLeave = (ev) =>
            {
                if (ev.preventDefault) ev.preventDefault()
                if (ev.target.classList) ev.target.classList.remove('dragover')
            }

            el.addEventListener('drop', drop)
            el.addEventListener('dragover', dragOver)
            el.addEventListener('dragenter', dragOver)
            el.addEventListener('dragleave', dragLeave)
        },

        componentUpdated (el, binding, vnode)
        {
            el.setAttribute('data-target', binding.value.target);
        },

        unbind (el, binding, vnode)
        {
            el.setAttribute('draggable', false)
            el.removeEventListener('dragstart', {})
        }
    });

    Vue.directive('dragenter',
    {
        bind (el, binding, vnode)
        {
            const dragEnter = (ev) =>
            {
                if (ev.preventDefault) ev.preventDefault()
                if (ev.stopPropagation) ev.stopPropagation()
                ev.target.classList.add('dragover')
                binding.value.call(el)
            }

            el.addEventListener('dragenter', dragEnter)
        },

        unbind (el, binding, vnode)
        {
            el.removeEventListener('dragenter', {})
        }
    });

    Vue.directive('dragleave',
    {
        bind (el, binding, vnode)
        {
            const dragLeave = (ev) =>
            {
                if (ev.preventDefault) ev.preventDefault()
                if (ev.stopPropagation) ev.stopPropagation()
                binding.value.call(el)
            }

            el.addEventListener('dragleave', dragLeave)
        },

        unbind (el, binding, vnode)
        {
            el.removeEventListener('dragleave', {})
        }
    });
}

export default DnD;



// WEBPACK FOOTER //
// ./src/js/plugins/vue2-dnd.js